var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitewheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.15175 18.4616L10.5803 34.9615H29.4197L38.8482 18.4615L29.4197 1.96155L10.5803 1.96155L1.15175 18.4616ZM10 0.961548L0 18.4616L10 35.9615H30L40 18.4616L30 0.961548H10ZM19.944 9.1967C25.1835 9.1967 29.4134 13.4853 29.4134 18.7538C29.4134 24.0223 25.1835 28.311 19.944 28.311C14.7045 28.311 10.4747 24.0223 10.4747 18.7538C10.4747 13.4853 14.7045 9.1967 19.944 9.1967ZM19.944 10.1967C24.6215 10.1967 28.4134 14.0279 28.4134 18.7538C28.4134 23.4798 24.6215 27.311 19.944 27.311C15.2665 27.311 11.4747 23.4798 11.4747 18.7538C11.4747 14.0279 15.2665 10.1967 19.944 10.1967Z",
    fill: "#F3F2EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitewheel);
export default __webpack_public_path__ + "static/media/whitewheel.288dfc2fc2acf9ea70a0d6c3f094a09c.svg";
export { ForwardRef as ReactComponent };